export interface EnvProperties {
  readonly BACKEND_RACINE_URL: string;
}

export class EnvService {
  private static config: EnvProperties;

  static initialize(config: EnvProperties): void {
    EnvService.config = config;
  }

  static get apiBaseUrl(): string {
    return EnvService.config?.BACKEND_RACINE_URL ?? '';
  }

  constructor(private readonly config: EnvProperties) {}

  get apiBaseUrl(): string {
    return this.config.BACKEND_RACINE_URL ?? '';
  }
}
